import { render, staticRenderFns } from "./FeedbackRequest.vue?vue&type=template&id=f6921234&"
import script from "./FeedbackRequest.vue?vue&type=script&lang=js&"
export * from "./FeedbackRequest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports